import styled from "styled-components";
import RangeSlider from "react-range-slider-input";
import {darken} from "polished";

export default styled(RangeSlider)`
    touch-action: none;
    user-select: none;
    cursor: pointer;
    display: block;
    position: relative;
    width: 100%;
    height: 2rem;
    background: ${props => props.theme.colors.secondaryBg};
    border: solid 1px ${props => darken(0.1, props.theme.colors.cardBg)};
    margin-top: .5rem;
    margin-bottom: .5rem;
    
    &[data-vertical] {
        height: 100%;
        width: .8rem;
    }
    
    &[data-disabled] {
        opacity: .5;
        cursor: default;
    }
    
    .range-slider__thumb {
        position: absolute;
        z-index: 3;
        top: -.25rem;
        width: .5rem;
        height: 2.5rem;
        transform: translate(-50%, -1px);
        background: ${props => props.theme.colors.primaryBg};
        border: solid 1px ${props => darken(0.1, props.theme.colors.cardBg)};
    }
    
    .range-slider__thumb:focus-visible {
      outline: 0;
      box-shadow: 0 0 0 6px rgba(33, 150, 243, 0.5);
    }
    
    &[data-vertical] .range-slider__thumb {
      left: 50%;
    }
    
    .range-slider__thumb[data-disabled] {
      z-index: 2;
    }
    
    .range-slider__range {
        position: absolute;
        z-index: 1;
        transform: translate(0, -50%);
        top: 50%;
        width: 100%;
        height: 100%;
        background: ${props => props.theme.colors.primaryBg};
    }
    
    &[data-vertical] .range-slider__range {
      left: 50%;
      transform: translate(-50%, 0);
    }
    
    input[type="range"] {
        -webkit-appearance: none;
        pointer-events: none;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 0;
        height: 0;
        background-color: transparent;
        border: none;
    }
    
    input[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
    }
    
    input[type="range"]::-moz-range-thumb {
        width: 0;
        height: 0;
        border: 0;
    }
    
    input[type="range"]:focus {
      outline: 0;
    }
`;
